import { request } from '@/shared/api/request'

export const getUnionTrade = async (externalId) => {
	return request({ url: `colcontract/tradeUnion/get/${externalId}`, method: 'GET' })
}
